import React, { useState } from 'react';
import ChangePalleteForm from './ChangePalleteForm'
import { Dialog, withStyles } from "@material-ui/core";
import { hasPermission } from '../../sc-utilities';
import { connect } from "react-redux";
import * as actions from "../PCProduct/store/pcProductActions";
import * as Yup from "yup";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },

    cancel: {
        width: "250px",
        margin: "10px"
    }
});

const ChangePalette = props => {
    const { product, loading, isPrinted, changePaletteState, activeCustomer, translations, permissions } = props;
    const [transportOption, setTransportOption] = useState(null)
    const handleSubmit = async data => {
        data['ProductID'] = product.ProductID;
        await props.moveToAnotherPalette({ ...data, ActiveCustomerID: activeCustomer });
        props.handleChangePalette();
    }
    const handleCancel = async data => {
        props.handleChangePalette();
    }
    const optionTransport = (id) => {
        let transport = changePaletteState.orders.filter(order => id.target.value === order.value)
        setTransportOption(transport.TransportCollies)
    }


    let initialValues = {
        OrderID: product && product.OrderID ? `${product.OrderID}` : '',
        TransportColliID: product && product.TransportColliID ? `${product.TransportColliID}` : '',
        ColliID: product && product.ColliID ? `${product.ColliID}` : '',
    };

    let formSettings = {
        Option: changePaletteState.orders.filter(order => (product && product.OrderID ? `${product.OrderID}` : '') === order.value),
        Validation: {
            OrderID: Yup.string().required("Required"),
            TransportColliID: Yup.string().required("Required"),
            ColliID: Yup.string().required("Required"),

        },
        ButtonSubmit: hasPermission(permissions, "product_print_label")
            ? {
                Title: translations["save"] || "SAVE",
                Color: 'primary'
            }
            : null,
        ButtonCancel: {
            Title: translations["cancel"] || "CANCEL",
            handleCancel: handleCancel,
        }
    };
    return (
        <Dialog
            open={changePaletteState.open}
            disableBackdropClick={false}
            disableEscapeKeyDown={false}
            fullWidth={true}
            onClose={handleCancel}
        >                <ChangePalleteForm
            formSettings={formSettings}
            initialValues={initialValues}
            handleSubmit={handleSubmit}
            loading={loading}
            transportOption={transportOption}
            optionTransport={optionTransport}
            isPrinted={isPrinted}
            changePaletteState={changePaletteState}
            translations={translations}
        ></ChangePalleteForm>
        </Dialog>
    )
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onEditPCProduct: product => dispatch(actions.editPCProduct(product)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ChangePalette));
